<!-- @format -->

<ng-container *transloco="let t">
  <app-cart-wizard-container [wizardStepKeys]="wizardSteps" [currentStep]="currentStep">
    <fudis-grid [rowGap]="'lg'">
      <!-- Autofocus the heading to help screen readers start from the essential, _new_ information. -->
      <app-cart-wizard-step-heading [wizardStepKeys]="wizardSteps" [currentWizardStepIndex]="currentStep" tabindex="-1" sisAutofocus />
      <fudis-body-text>{{ t("OPEN_UNIVERSITY.STUDY_VOUCHER_STUDIES_ACTIVATE.DESCRIPTION") }}</fudis-body-text>

      <fudis-dl [variant]="'regular'" [rowGap]="'none'" [columns]="{ sm: 1, md: 'inputLg inputLg' }" [columnGap]="'xxl'">
        <fudis-dl-item>
          <fudis-dt [contentText]="t('PROFILE.FIRST_NAMES')" />
          <fudis-dd data-cy="study-voucher-activate-person-first-names">
            {{ suomiFiUserBasicDetails.firstNames }}
          </fudis-dd>
        </fudis-dl-item>

        <fudis-dl-item>
          <fudis-dt [contentText]="t('PROFILE.LAST_NAME')" />
          <fudis-dd data-cy="study-voucher-activate-person-last-name">
            {{ suomiFiUserBasicDetails.lastName }}
          </fudis-dd>
        </fudis-dl-item>
      </fudis-dl>

      @if (form$ | async; as form) {
        <app-suomi-fi-user-details-form-fields [form]="form" [suomiFiUserBasicDetails]="suomiFiUserBasicDetails" />

        <sis-wizard-step-buttons
          [forwardButtonTitle]="t('OPEN_UNIVERSITY.STUDY_VOUCHER_STUDIES_ACTIVATE.CONFIRM_BUTTON')"
          [backButtonDisplay]="false"
          [forwardButtonDisabled]="(activationInProgress$ | async) ?? false"
          (forward)="activate(form)">
        </sis-wizard-step-buttons>
      }
    </fudis-grid>
  </app-cart-wizard-container>
</ng-container>
